import React, { useEffect, useState } from 'react';
import CollapseList from '@/components/collapse-list';
import styles from './index.scss';
import cx from 'classnames';
import {
  LearningInfo,
  LearningType,
} from '@/api/seller/serv/oec_seller_learning_center_api';
import { useTranslation } from '@jupiter-app/plugin-i18n';
import LearnMore from '@/components/learn-more';
import { PagePathV2 } from '@/types';
import { useHistory } from 'react-router-dom';
import { Tea } from '@features/libs/tea';
import { useContextUser } from '@features/hooks';
import { useUserModel } from '@/models';
import { REGION_CONFIG } from '@/region-config';

interface FaqPieceProps {
  faqData?: Array<LearningInfo>;
  error?: boolean;
}

const FaqPiece: React.FC<FaqPieceProps> = props => {
  const { i18n, t } = useTranslation();
  const [user] = useContextUser();
  const { isLogin, isSeller } = useUserModel();
  const history = useHistory();
  const onClickLearnMore = () => {
    history.push({
      pathname: PagePathV2.FAQ,
    });
    Tea('button_click', {
      page_name: 'seller_university_homepage',
      is_login: !!user.user_id,
      module_name: 'faq',
      click_for: 'more',
    });
  };
  const [hardFAQ, setHardFAQ] = useState<LearningInfo | undefined>();
  useEffect(() => {
    if (
      ((isLogin === 1 && isSeller) || isLogin !== 1) &&
      REGION_CONFIG.larkRefs.faq
    ) {
      setHardFAQ({
        learning_id: -1,
        learning_type: LearningType.Knowledge,
        content: `${t('academy_larkcommunityfaqbody')} ${t(
          'academy_larkcommunityfaqcta',
        )} ${REGION_CONFIG.larkRefs.faq}`,
        name: t('academy_larkcommunityfaqtitle'),
      });
    } else {
      setHardFAQ(undefined);
    }
  }, [isLogin, isSeller, i18n.language, t]);

  useEffect(() => {
    if (hardFAQ) {
      Tea('page_show', {
        page_name: 'academy_faq_lark_community',
        module_name: 'academy_faq_lark_community',
      });
    }
  }, [hardFAQ]);

  return !props.error ? (
    <div className={styles.faqContainer}>
      <div className="flex flex-col py-40" style={{ width: 1280 }}>
        <p className={cx(styles.title)}>{t('academy_homepage_faq_title')}</p>
        <CollapseList
          dataList={
            hardFAQ ? [hardFAQ, ...(props.faqData ? props.faqData : [])] : []
          }
          pageName={'seller_university_homepage'}
        />
        {props.faqData && (
          <LearnMore classNames="mt-32" onClickLearnMore={onClickLearnMore} />
        )}
      </div>
    </div>
  ) : null;
};
export default FaqPiece;
